import AudioBackgroundProps from "../../components/Common/AudioBackground/AudioBackground";
import { actions, store } from "../../redux";
import { PostAudioProps } from "../../redux/slices/postAudio/postAudio";
import { API_INSTANCES } from "../api_instance";
import { handleError } from "../errors";

const dispatch = store.dispatch;

const uploadAudioToAPost = (
  payload: PostAudioProps.uploadAudioToAPostPayload
) => {
  dispatch(actions.postAudio.setIsUploading(true));
  return API_INSTANCES.POSTAUDIO.uploadAudioToAPost(payload)
    .then((response) => {
      const data = response.data as PostAudioProps.Audio;
      dispatch(actions.postAudio.setUploadedAudio(data));
    })
    .catch((error) => handleError(error, "uploadAudioToAPost"))
    .finally(() => {
      dispatch(actions.postAudio.setIsUploading(false));
    });
};

const createAudioDraftForAPost = (
  payload: PostAudioProps.createAudioDraftForAPostPayload
) => {
  return API_INSTANCES.POSTAUDIO.createAudioDraftForAPost(payload)
    .then((response) => {
      const data =
        response.data as PostAudioProps.createAudioDraftForAPostResponse;
      dispatch(actions.postAudio.setUploadedAudioDraft(data));
    })
    .catch((error) => handleError(error, "createAudioDraftForAPost"));
};

const uploadAudioBackgroundImage = (
  payload: PostAudioProps.uploadAudioBackgroundImagePayload
) => {
  return API_INSTANCES.POSTAUDIO.uploadAudioBackgroundImage(payload)
    .then((response) => {
      const data = response.data as AudioBackgroundProps.AudioBackgroundImage;
      dispatch(actions.postAudio.setAudioBackgroundImage(data));
    })
    .catch((error) => handleError(error, "uploadAudioBackgroundImage"));
};

const deleteAnAudioImageFromAPost = (
  payload: PostAudioProps.deleteAnAudioImageFromAPostPayload
) => {
  return API_INSTANCES.POSTAUDIO.deleteAnAudioImageFromAPost(payload)
    .then(() => {
      dispatch(actions.postAudio.deleteAudioBackgroundImage());
    })
    .catch((error) => handleError(error, "deleteAnAudioImageFromAPost"));
};

const deleteAudioFromAPost = (
  payload: PostAudioProps.deleteAudioFromAPostPayload
) => {
  return API_INSTANCES.POSTAUDIO.deleteAudioFromAPost(payload)
    .then(() => {
      dispatch(actions.postAudio.reset());
    })
    .catch((error) => handleError(error, "deleteAudioFromAPost"));
};

const getPostAudio = (post_id: string) => {
  return API_INSTANCES.POSTAUDIO.getPostAudio(post_id)
    .then((response) => {
      const data = response.data as PostAudioProps.Audio;
      dispatch(actions.postAudio.setUploadedAudio(data));
    })
    .catch((error) => handleError(error, "getPostAudio"));
};
export const POSTAUDIO = {
  uploadAudioToAPost,
  createAudioDraftForAPost,
  uploadAudioBackgroundImage,
  deleteAnAudioImageFromAPost,
  deleteAudioFromAPost,
  getPostAudio,
};
